import { makeProjectionStateField } from "components/organisms/manuscript/overleaf/completion/utils/projection-state-field";
import { enterNode } from "components/organisms/manuscript/overleaf/completion/utils/tree-operations/environments";
export const documentEnvironments = makeProjectionStateField(enterNode);
